import { render, staticRenderFns } from "./contact-relations-list-group-input.vue?vue&type=template&id=72b10d60&scoped=true&"
import script from "./contact-relations-list-group-input.vue?vue&type=script&lang=ts&"
export * from "./contact-relations-list-group-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b10d60",
  null
  
)

export default component.exports